import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api';
import { useAuth } from '../context/AuthContext';
import { useT } from '../i18n';
import LanguageToggle from '../components/LanguageToggle';

export default function Login() {
  const t = useT();
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const data = await login({ code, password });
      loginUser(data.token, data.user);
      navigate(data.user.role === 'customer' ? '/my-shipments' : '/dashboard');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.bg}>
      <style>{`
        .login-input:focus { outline:none; border-color: var(--accent) !important; box-shadow: 0 0 0 3px var(--accent-bg) !important; }
        .login-btn:hover:not(:disabled) { background: var(--accent-bg) !important; border-color: var(--accent) !important; }
        .login-btn:disabled { opacity:0.45; cursor:not-allowed; }
      `}</style>

      <div style={s.grid} />

      <div style={s.langCorner}>
        <LanguageToggle inline />
      </div>

      <div style={s.card}>
        <div style={s.header}>
          <img src="/logo.png" alt="KDExpress" style={s.logoImg} />
          <div style={s.subtitle}>{t('CHECKOUT SYSTEM')}</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>{t('LOGIN CODE')}</label>
            <input
              className="login-input"
              style={s.input}
              value={code}
              onChange={e => setCode(e.target.value)}
              placeholder="admin · P0AX · ..."
              autoFocus
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>{t('PASSWORD')}</label>
            <input
              className="login-input"
              style={s.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder={t('Enter password...')}
            />
          </div>

          <button className="login-btn" style={s.btn} type="submit" disabled={loading}>
            {loading ? t('Authenticating...') : t('Sign in →')}
          </button>

          {error && <div style={s.error}>{error}</div>}
        </form>
      </div>
    </div>
  );
}

const s = {
  bg: {
    minHeight:'100vh', background:'var(--bg-primary)',
    display:'flex', alignItems:'center', justifyContent:'center',
    position:'relative', overflow:'hidden',
  },
  grid: {
    position:'absolute', inset:0,
    backgroundImage:'linear-gradient(rgba(15,23,42,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(15,23,42,0.025) 1px,transparent 1px)',
    backgroundSize:'40px 40px',
    maskImage:'radial-gradient(ellipse at center,black 30%,transparent 80%)',
    WebkitMaskImage:'radial-gradient(ellipse at center,black 30%,transparent 80%)',
  },
  card: {
    background:'var(--bg-secondary)',
    border:'1px solid var(--border-strong)',
    borderRadius:'var(--radius-xl)', padding:'36px 32px',
    width:'100%', maxWidth:400,
    boxShadow:'var(--shadow-md)',
    position:'relative', zIndex:1,
  },
  header: {
    marginBottom:28,
    display:'flex', flexDirection:'column', alignItems:'center', gap:10,
  },
  logoImg: { height:56, width:'auto', display:'block', objectFit:'contain' },
  subtitle: {
    fontSize:11, fontWeight:600, color:'var(--text-secondary)',
    letterSpacing:'0.14em', textAlign:'center',
  },
  field: { marginBottom:18 },
  label: {
    display:'block',
    fontSize:10, fontWeight:500, color:'var(--text-muted)',
    letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:7,
  },
  input: {
    width:'100%', background:'var(--bg-secondary)',
    border:'1px solid var(--border-strong)',
    borderRadius:'var(--radius-md)', padding:'11px 14px',
    fontSize:14, color:'var(--text-primary)',
    transition:'border-color 160ms, box-shadow 160ms',
  },
  error: {
    color:'var(--color-danger)', fontSize:13, fontWeight:500,
    textAlign:'center', marginTop:14,
  },
  langCorner: {
    position:'fixed', top:12, right:12, zIndex:300,
  },
  btn: {
    width:'100%', background:'var(--bg-secondary)', color:'var(--text-primary)',
    border:'1px solid var(--border-strong)',
    borderRadius:'var(--radius-md)', padding:'13px',
    fontSize:14, fontWeight:600, cursor:'pointer',
    transition:'background-color 160ms, border-color 160ms',
    marginTop:4, letterSpacing:'0.01em',
    boxShadow:'var(--shadow-sm)',
  },
};
